import { Button, Label, TextInput, Table, Select, Alert } from "flowbite-react";
import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSidebar } from "../../../context/SidebarOpenContext";
import Breadcrumb from "../../../hooks/Breadcrumb";
import { FaPlus } from "react-icons/fa";
import CustomSelect from "../../../hooks/CustomSelect";
import CustomSelectwithText from "../../../hooks/CustomSelectwithText";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import AGroupBoxingQuantity from "./AGroupBoxingQuantity";
function AddGroupBoxing() {
    const { user } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const orderid = searchParams.get("id");
    const navigate = useNavigate();
    const [Colour, setColour] = useState({});
    const url = localStorage.getItem("url");
    const [Marker, setMarker] = useState({});
    const [boxNoOptions, setBoxNoOptions] = useState([]);
    const [selectedBoxNo, setSelectedBoxNo] = useState("");
    const [date, setDate] = useState("");
    const [SizeVarientOptions, setSizeVarientOptions] = useState({});
    const [available_quantityFlag, setavailable_quantityFlag] = useState(0);
    const today = new Date().toISOString().split('T')[0];
    const [miniBoxes, setMiniBoxes] = useState([
        { miniBoxNo: "", tables: [{ rows: [{ colour: null, selectedMarker: null }] }] }
    ]);
    const [transformedData, setTransformedData] = useState({});
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {

        }
    }, [user, navigate]);


    const { isSidebarOpen } = useSidebar();

    useEffect(() => {
        if (orderid) {
            fetchavailablequantity();
        }
    }, [orderid]);

    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",

        },
        {
            href: `/boxing?id=${orderid}`,
            label: "Boxing",

        },
        {
            label: "Add Group Boxing",
        },

    ];

    const fetchavailablequantity = async () => {
        try {
            const response = await axios.get(`/group_boxing/get_available_flag/${orderid}`);
            const availableQuantityData = response.data.available_quantity;
            if (response.data.success == 2) {
                fetchBoxNos();
                fetchmarker();
                fetchColour();
            }

            setavailable_quantityFlag(response.data.success)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };


    const fetchBoxNos = async () => {
        try {
            const response = await axios.get(`/group_boxing/box_no/${orderid}`);
            // console.log(response);

            // Extract box_no array from response.data
            setBoxNoOptions(response.data.box_no || []);
        } catch (error) {
            console.error("Error fetching box numbers:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const requestData = {
            order_id: orderid,
            date: today,
            box_no: selectedBoxNo,
            staff_id: user.staff_id,
            minibox: miniBoxes
        };
        try {
            axios
                .post('group_boxing/group_boxing', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Boxing Completed ",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        navigate(`/boxing?id=${orderid}`);
                    }
                    else if (response.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Quantity  exceeds the allowed limit....",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });

                    }
                    else if (response.data.success === 3) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message,
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });

                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }



                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const createBoxNo = async () => {
        try {
            const response = await axios.post(`/group_boxing/box_no/${orderid}`);
            const newBoxNo = response.data;
            const alreadyExists = boxNoOptions.includes(newBoxNo);
            if (!alreadyExists) {
                setBoxNoOptions([...boxNoOptions, newBoxNo]);
            }
    
            setSelectedBoxNo(newBoxNo);
        } catch (error) {
            console.error("Error creating box number:", error);
        }
    }

    const fetchmarker = async () => {
        try {
            const response = await axios.get(`/group_boxing/sizevarient_options/${orderid}`);
            const markerData = response.data.size_options;
            setSizeVarientOptions(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const fetchColour = async () => {
        try {
            const response = await axios.get(`/group_boxing/color_options/${orderid}`);
            const ColourData = response.data.color_options;

            const formattedColours = ColourData.map(colour => ({
                ...colour,
                imgSrc: colour.imgSrc ? `${url}${colour.imgSrc}` : null
            }));

            setColour(formattedColours);

        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const duplicateMiniBox = (miniBoxIndex) => {
        const updatedBoxes = [...miniBoxes];
        const original = updatedBoxes[miniBoxIndex];
        const duplicatedBox = {
            miniBoxNo: "", // Empty the duplicated mini box number
            tables: original.tables.map(table => ({
                rows: table.rows.map(row => ({
                    colour: row.colour,
                    selectedMarker: row.selectedMarker,
                }))
            }))
        };
        updatedBoxes.push(duplicatedBox);
        setMiniBoxes(updatedBoxes);
    };


    // Handle Mini Box No. Input Change
    const handleMiniBoxNoChange = (index, value) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[index].miniBoxNo = value;
        setMiniBoxes(updatedBoxes);
       
    };

    // Add Mini Box
    const addMiniBox = () => {
        
        setMiniBoxes([...miniBoxes, { miniBoxNo: "", tables: [{ rows: [{ colour: null, selectedMarker: null }] }] }]);
//    console.log(miniBoxes)
    };

    // Delete Mini Box
    const deleteMiniBox = (miniBoxIndex) => {
        if (miniBoxes.length > 1) {
            setMiniBoxes(miniBoxes.filter((_, index) => index !== miniBoxIndex));
        }
    };

    // Add Table
    const addTable = (miniBoxIndex) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables.push({ rows: [{ colour: null, selectedMarker: null }] });
        setMiniBoxes(updatedBoxes);
    };

    // Delete Table
    const deleteTable = (miniBoxIndex, tableIndex) => {
        if (miniBoxes[miniBoxIndex].tables.length > 1) {
            const updatedBoxes = [...miniBoxes];
            updatedBoxes[miniBoxIndex].tables.splice(tableIndex, 1);
            setMiniBoxes(updatedBoxes);
        }
    };

    // Add Row
    const addRow = (miniBoxIndex, tableIndex) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows.push({ colour: null, selectedMarker: null });
        setMiniBoxes(updatedBoxes);
        
    };

    // Delete Row
    const deleteRow = (miniBoxIndex, tableIndex, rowIndex) => {
        if (miniBoxes[miniBoxIndex].tables[tableIndex].rows.length > 1) {
            const updatedBoxes = [...miniBoxes];
            updatedBoxes[miniBoxIndex].tables[tableIndex].rows.splice(rowIndex, 1);
            setMiniBoxes(updatedBoxes);
        }
    };

    // Handle Colour Change
    const handleColourChange = (miniBoxIndex, tableIndex, rowIndex, selectedOptions) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows[rowIndex].colour = selectedOptions;
        setMiniBoxes(updatedBoxes);
    
       
    };

    // Handle Marker Change
    const handleMarkerChange = (miniBoxIndex, tableIndex, rowIndex, selectedOptions) => {
        const updatedBoxes = [...miniBoxes];
        updatedBoxes[miniBoxIndex].tables[tableIndex].rows[rowIndex].selectedMarker = selectedOptions;
        setMiniBoxes(updatedBoxes);
        // console.log(updatedBoxes)
        const transformed = transformData(updatedBoxes);
        // console.log(transformed)
        setTransformedData(transformed);
    };

    const transformData = (data) => {
        const result = {};
    
        data.forEach(miniBox => {
            miniBox.tables.forEach(table => {
                table.rows.forEach(row => {
                    const { colour, selectedMarker } = row;
    
                    // Ensure selectedMarker is not null or undefined and is an object
                    if (selectedMarker && typeof selectedMarker === 'object') {
                        if (!result[colour]) {
                            result[colour] = {};
                        }
    
                        Object.keys(selectedMarker).forEach(key => {
                            const value = parseInt(selectedMarker[key], 10);
                            result[colour][key] = value;
                        });
                    }
                });
            });
        });
    
        return result;
    };
    

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14  h-full">
                <div className="p-4 rounded-lg shadow bg-white ">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        {available_quantityFlag === 1 && (
                            <Alert color="failure" className="mt-2">
                                Pressing section has not completed
                            </Alert>
                        )}

                        {available_quantityFlag === 3 && (
                            <Alert color="failure" className="mt-2">
                                Unable to add. The pressing quantity has already been fully transferred to Boxing.
                            </Alert>
                        )}
                        {available_quantityFlag !== 1 && available_quantityFlag !== 3 && (
                            <>
                                    <div className="sticky top-16 bg-white z-10">
                                <div className=" flex items-center pt-2">
                                    <h3 className="text-lg font-medium text-sidebar-color dark:text-white mr-2">
                                        Add Group Boxing
                                    </h3>
                                    <Button className="bg-sidebar-color text-white" size="xs" onClick={(e) => {
                                        e.preventDefault();
                                        addMiniBox();
                                    }}> Add Mini Box</Button>
                                </div>
                        
    <AGroupBoxingQuantity orderid={orderid} transformedData={transformedData} />
</div>


                                <div className="flex gap-4">
                                    <div className="w-1/2">
                                        <div className="mb-2 block  ">
                                            <Label htmlFor="password" value="Date" />
                                        </div>
                                        <TextInput
                                            name="orderdate"
                                            type="date"
                                            value={today} // set default value
                                            min={today}   // disable past dates
                                            max={today}
                                            required
                                            autoComplete="off"
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="w-1/2">
                                        <div className="mb-2 block">
                                            <Label htmlFor="boxNo" value="Box No" />
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            {/* <TextInput className='w-full' name="box_no" type="text" required value={selectedBoxNo} onChange={(e) => setSelectedBoxNo(e.target.value)} disabled /> */}
                                            <Select
                                                className='w-full'
                                                name="box_no"
                                                value={selectedBoxNo}
                                                onChange={(e) => setSelectedBoxNo(e.target.value)}
                                                required
                                            >
                                                <option value="">Select Box No</option>
                                                {boxNoOptions.length > 0 ? (
                                                    boxNoOptions.map((box, index) => (
                                                        <option key={index} value={box}>{box}</option>
                                                    ))
                                                ) : (
                                                    <option disabled>No boxes available</option>
                                                )}
                                            </Select>
                                            <Button size="xs" className='pt-1 pb-1' color="blue" onClick={createBoxNo} >
                                                <FaPlus />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div>

                                    {miniBoxes.map((miniBox, miniBoxIndex) => (
                                        <div key={miniBoxIndex} className="border p-4 mb-6 rounded-lg shadow-md relative">
                                            {/* Mini Box Header */}
                                            <div className="flex justify-between items-center">
                                                <div className="w-1/2">
                                                    <div className="mb-2 flex items-center">
                                                        <Label htmlFor="minibox" value="Mini Box No" />
                                                        <Button className="ml-2 bg-sidebar-color text-white" size="xs" onClick={() => addTable(miniBoxIndex)}>
                                                            Add Assortment
                                                        </Button>
                                                        <Button className="ml-2 bg-blue-500 text-white" size="xs" onClick={() => duplicateMiniBox(miniBoxIndex)}>
                                                            Copy Mini Box
                                                        </Button>

                                                    </div>
                                                    <TextInput
                                                        name="miniboxNo"
                                                        type="text"
                                                        required
                                                        autoComplete="off"
                                                        value={miniBox.miniBoxNo}
                                                        onChange={(e) => handleMiniBoxNoChange(miniBoxIndex, e.target.value)}
                                                    />
                                                </div>

                                                {miniBoxes.length > 1 && (
                                                    <IoMdClose
                                                        size={24}
                                                        className="text-red-500 cursor-pointer"
                                                        onClick={() => deleteMiniBox(miniBoxIndex)}
                                                    />
                                                )}
                                            </div>


                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                {miniBox.tables.map((table, tableIndex) => (
                                                    <div key={tableIndex} className="mt-4 p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">
                                                        {/* Table Header */}
                                                        <div className="flex justify-between items-center">
                                                            <div className="flex items-center">
                                                                <h4 className="text-md font-medium">Assortment {tableIndex + 1}</h4>
                                                                <Button
                                                                    className="ml-2 bg-sidebar-color text-white"
                                                                    size="xs"
                                                                    onClick={() => addRow(miniBoxIndex, tableIndex)}
                                                                >
                                                                    Add Row
                                                                </Button>
                                                            </div>
                                                            {miniBox.tables.length > 1 && (
                                                                <IoMdClose
                                                                    size={24}
                                                                    className="text-red-500 cursor-pointer"
                                                                    onClick={() => deleteTable(miniBoxIndex, tableIndex)}
                                                                />
                                                            )}
                                                        </div>
                                                        {/* Assortment Grid (3 in a row) */}
                                                        {table.rows.map((row, rowIndex) => (
                                                            <div key={rowIndex} className="border p-3 flex flex-col gap-2 m-2 ">
                                                                {table.rows.length > 1 && (
                                                                    <IoMdClose
                                                                        size={24}
                                                                        className="text-red-500 cursor-pointer self-end"
                                                                        onClick={() => deleteRow(miniBoxIndex, tableIndex, rowIndex)}
                                                                    />
                                                                )}
                                                                {/* Colour Selection */}
                                                                <CustomSelect
                                                                    value={row.colour}
                                                                    onChange={(selectedOptions) =>
                                                                        handleColourChange(miniBoxIndex, tableIndex, rowIndex, selectedOptions)
                                                                    }
                                                                    options={Colour.length > 0 ? Colour : []}
                                                                    placeholder="Select a colour"
                                                                />

                                                                {/* Marker Selection */}
                                                                <CustomSelectwithText
                                                                    value={row.selectedMarker}
                                                                    onChange={(selectedOptions) =>
                                                                        handleMarkerChange(miniBoxIndex, tableIndex, rowIndex, selectedOptions)
                                                                    }
                                                                    options={SizeVarientOptions.length > 0 ? SizeVarientOptions : []}
                                                                />

                                                                {/* Delete Row Button */}

                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}

                                    <div className="flex justify-center gap-4 pt-4">
                                        <Button
                                            className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                                            type="button"
                                            onClick={handleSubmit}
                                        >
                                            {"Submit"}
                                        </Button>
                                    </div>

                                </div>
                            </>)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddGroupBoxing;
